import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UIIconColor } from '../../../icon/icon-color.type';
import { UIIcon } from '../../../icon/icon.enum';

@Component({
  selector: 'ui-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIBannerComponent {
  readonly color = input<'neutral' | 'error' | 'success' | 'warning' | 'info' | 'highlight'>('neutral');
  readonly textAlign = input<'left' | 'center'>('left');
  readonly fullWidth = input<boolean>(false);
  readonly icon = input.required<`${UIIcon}`>();

  get iconColor(): UIIconColor {
    const iconColors: { [key: string]: UIIconColor } = {
      neutral: 'french-azure',
      error: 'red',
      success: 'green',
      warning: 'orange',
      info: 'charcoal',
      highlight: 'grape',
    };
    return iconColors[this.color()];
  }
}
